// extracted by mini-css-extract-plugin
export default {"backButton":"style_backButton__yE0SE","img":"style_img__GwLgI","title":"style_title__WrF1z"};